export enum CoinsGiftStatus {
  PENDING = 'PENDING',
  DELIVERED = 'DELIVERED',
  EXPIRED = 'EXPIRED',
}
